import React, { useEffect, useState } from 'react';
import { Box, Typography } from '@mui/material';
import { LineChart } from '@mui/x-charts/LineChart';
import {
  enrichAndSortData,
  getLabels,
  getXAxisDateTimeOptions,
  NumberCompactFormatter,
} from '../../../../utils/chartData';

// COMPONENTS
import CardWrapper from '../../CardWrapper';
import Loader from '../../../common/Loader';

// MESSAGES
import HomeFormattedMessages from '../../../../messages/HomeFormattedMessages';

// REQUESTS
import useDashboardRequest from '../../../../requests/DashboardRequest';

export default function ErrorsByTopCustomer({ errorHandler }) {
  const [chartData, setChartData] = useState({ labels: [], datasets: [] });
  const [loading, setLoading] = useState(true);
  const { getErrorsByTopCustomers } = useDashboardRequest();

  const loadData = async () => {
    const response = await getErrorsByTopCustomers(errorHandler);

    const enrichedData = enrichAndSortData(response);
    const labels = getLabels(enrichedData);

    const groupByFlag = {};

    enrichedData.forEach(({ customer_name, label, errorCount }) => {
      if (!groupByFlag[customer_name]) {
        groupByFlag[customer_name] = {};
      }
      groupByFlag[customer_name][label] = errorCount;
    });

    const datasets = Object.entries(groupByFlag).map(
      ([customer_name, dataMap]) => ({
        label: customer_name,
        data: labels.map((label) => dataMap[label] || 0),
        showMark: ({ index }) =>
          labels.map((label) => dataMap[label] || 0)[index] > 0,
      })
    );

    setChartData({ labels, datasets });
    setLoading(false);
  };

  useEffect(() => {
    loadData();
  }, []);

  return (
    <CardWrapper title={HomeFormattedMessages.errorsByTopCustomers}>
      {loading ? (
        <Loader />
      ) : chartData.datasets.length === 0 ? (
        <Box sx={{ marginTop: 1 }}>
          <Typography>{HomeFormattedMessages.noDataAvailable}</Typography>
        </Box>
      ) : (
        <Box sx={{ marginX: -4, marginBottom: -2 }}>
          <LineChart
            height={250}
            xAxis={getXAxisDateTimeOptions(chartData.labels)}
            yAxis={[
              {
                valueFormatter: (value, context) =>
                  NumberCompactFormatter.format(value),
              },
            ]}
            series={chartData.datasets}
            grid={{ horizontal: true }}
          />
        </Box>
      )}
    </CardWrapper>
  );
}
